import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { FormModalContainer, useCloseConfirm } from '../../Form'
import { useResizeModal } from '../../Modal'
import { ProviderForm } from '../ProviderForm'

import { QA_NAME_PROVIDER_CREATION_MODAL } from './ProviderFormModal.constants'

function ProviderFormModal({
  title = 'Modal.ProviderFormAddTitleKey',
  onClose,
  ...restProps
}) {
  const { t } = useTranslation()

  const [modal, setModal] = useState(null)

  function handleCloseModal() {
    return setModal(null)
  }

  const { handleClose, isCloseConfirm, setCloseConfirm } = useCloseConfirm({
    onClose,
  })

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const { fullScreen, handleResizeModal } = useResizeModal()

  return (
    <ProviderForm
      {...restProps}
      FormContainer={FormModalContainer}
      containerProps={{
        isCloseConfirm,
        isFullScreen: isMobileScreenSize || fullScreen,
        modal,
        qaName: QA_NAME_PROVIDER_CREATION_MODAL,
        setCloseConfirm,
        title: t(title),
        onClose,
        onResize: isMobileScreenSize ? undefined : handleResizeModal,
      }}
      contentComponentProps={{ isFullScreen: isMobileScreenSize || fullScreen }}
      setModal={setModal}
      onCancel={handleClose}
      onCloseModal={handleCloseModal}
    />
  )
}

export default ProviderFormModal
